<template lang="pug">
div
  .mb-3
    IconBtn(@click="create", icon="mdi-plus", title="Group")
  List(@edit="edit")
  Form(ref="form")
</template>

<script>
import List from "./List";
import Form from "./Form/index";

export default {
  components: { List, Form },
  methods: {
    create() {
      this.$refs.form.open();
    },
    edit(group) {
      this.$refs.form.open(group);
    },
  },
};
</script>